const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden', // Prevent scrolling
      overflowY: 'hidden', // Explicitly hide vertical scrollbar
      maxHeight: '100%',
      justifyContent: 'space-between', // Distribute space between elements
    },
    contentArea: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      flex: 1,
      justifyContent: 'center',
      padding: '0 24px',
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '20px',
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
    cancelImage: {
      height: '160px',
      width: 'auto',
    },
    // Title is now moved to PopupContainer title prop
    description: {
      margin: '0 0 8px 0',
      fontSize: '16px',
      color: 'rgba(255, 255, 255, 0.8)',
      lineHeight: 1.5,
    },
    refundMessage: {
      margin: '0 0 24px 0',
      fontSize: '14px',
      color: 'rgba(255, 255, 255, 0.6)',
    },
    buttonContainer: {
      width: '100%',
      padding: '0 24px 24px 24px',
      marginTop: 'auto',
    },
    closeButton: {
      margin: '0px !important',
      width: '100%',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
